import React, { useState, useEffect } from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from "../../../config/ui.js";
import PAGES from "../../data/PagesConstants.js";
import { getApi } from "../../api/endpoints.js";
import { toast } from "react-toastify";
import DetailsComponent from "../../components/DetailsComponent.js";
import ServiceTypeMap from "../../models/ServiceTypeMap.js";
import FormPartial from "./FormPartial.js";

const SearchUserPage = () => {
  const [searchApi] = getApi('findUser');
  const [credential, setCredential] = useState("");
  const [credentialError, setCredentialError] = useState("");
  const [userDetails, setUserDetails] = useState([]);
  const serviceTypeObj = new ServiceTypeMap();
  const [serviceType, setServiceType] = useState(serviceTypeObj.toStateJson());
  const [createServiceTypesMappingsApi] = getApi('createServiceTypesMappings');

  useEffect(() => {
    if(Object.keys(userDetails).length !== 0){
      serviceType.user_id = userDetails.id;
    }
  })

  const onSearchClick = (e) => {
    e.preventDefault();
    setServiceType(serviceTypeObj.toStateJson());
    if(credential.trim() === ""){
      setCredentialError("This field cannot be blank.");
      setUserDetails({});
    } else {
      getRecords(credential);
      setCredentialError("");
    }
  }

  const getRecords = async (params) => {
    try{
      let response = await searchApi({search: params}).unwrap();
      setUserDetails(response.data.users);
      if(Object.keys(response.data.users).length === 0){
        setCredentialError("NO USER FOUND!");
      } else {
        setCredentialError("");
      }
    } catch(error) {
      setUserDetails({});
    }
  }



  const onCredentialChange = (event) => {
    setCredential(event.target.value);
  }

  const onSubmit = (event) => {
    try{
      createRecord((new ServiceTypeMap(serviceType)).toApiJson());
    } catch(error){
      setServiceType(new ServiceTypeMap(serviceType));
    }
  }

  const createRecord = async (params) => {
    try {
      await createServiceTypesMappingsApi(params).unwrap();
      toast.success("User Mapped Successfully.");
      setServiceType(new ServiceTypeMap());
    } catch(error) {
      toast.error(error.data.message);
      setServiceType(new ServiceTypeMap());
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.SearchUserPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Search User" }]}
    className={'search-user-page'}
  >
    <PageContentWrapper contentHeading={"Search User"}>
      <div className="d-flex justify-content-center">
        <form onSubmit={onSearchClick} className="row m-4 d-flex justify-content-center">
          <input
            id="credential"
            value={credential}
            onChange={onCredentialChange}
            className="form-control form-control-sm font-size-12"
            placeholder="Enter credential to search user"
            type="text"
            aria-describedby="credential_help"
          />
          <div id="credential_help" className="form-text text-danger mt-0">
            {credentialError}
          </div>
          <button
            className="s-btn-filled my-1 font-size-11"
            type="submit"
            style={{width: '90px', height: '20px'}}
          >
            Search User
          </button>
        </form>
      </div>
      <hr />
        {Object.keys(userDetails).length !== 0 &&
        <>
          <div className="row">
            <u><h5 className="text-success mx-2">{userDetails.length} users found</h5></u>
            { userDetails.map((detail, index)=>{
              return <div><DetailsComponent data={detail} /><hr/></div>
            }) }
          </div>
        </>
        }
    </PageContentWrapper>
  </Page>
};

export default SearchUserPage;
